import {Navigate} from 'react-router'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {logErrorAsUnhandled} from '../../common/helpers/exception-handlers/bugsnag-client'
import {displayNotification} from '../../common/helpers/helpers'
import {UserVisiblePageError} from '../../errors/user-visible-page-error'
import {mkFailureToLoad} from '../use-chromeless-post-message'
import {useAccessedChromeless} from './access'
import {useChromeless} from './hook'

export const NavigateUnlessChromeless = ({
  error,
  route,
  userMessage,
}: {
  error: Error
  route: string
  userMessage?: string
}) => {
  const {t} = useSafeTranslation()
  const chromeless = useChromeless()
  const accessedChromeless = useAccessedChromeless()
  const userFacingMessage = userMessage ?? t('COMMON_ERROR_MESSAGE')

  console.error(error)
  logErrorAsUnhandled(error)
  if (chromeless || accessedChromeless) {
    throw new UserVisiblePageError({
      title: userFacingMessage,
      chromelessPostMessage: mkFailureToLoad(),
      accessedChromeless,
    })
  } else {
    displayNotification('error', userFacingMessage)
    return <Navigate to={route} replace />
  }
}
